export const searchNormaliz = (text: string) => {
    const normalizationSearchText = text
        .normalize('NFKC')
        .toLowerCase() // normalize
        .replace(/\s+/g, '') // 空白変換
        .replace(/[-－―‐ー]/g, '－') // ハイフン変換
        .replace('¥', '￥') // ¥を全角変換
        .replace('~', '～') // ~を全角変換
        .replace("'", '’') // 'を全角変換
        .replace('"', '”') // "を全角変換
        .replace('/', '／') // /を全角変換
        .replace('･"', '・'); // ･を全角変換

    return normalizationSearchText;
};

export const productNameNormaliz = (text: string) => {
    // 検索結果一覧でハイライト処理をするための機種名の空白を除去しないノーマライズ
    const normalizationSearchText = text
        .normalize('NFKC')
        .toLowerCase() // normalize
        .replace(/[-－―‐ー]/g, '－') // ハイフン変換
        .replace('¥', '￥') // ¥を全角変換
        .replace('~', '～') // ~を全角変換
        .replace("'", '’') // 'を全角変換
        .replace('"', '”') // "を全角変換
        .replace('/', '／') // /を全角変換
        .replace('･"', '・'); // ･を全角変換
    return normalizationSearchText;
};
